import { useState } from 'react';
import { HeaderWrapper, Layout, TableCell, TableLayout } from 'components/Hospital/PaginationForms';
import { consultationListHeader, diagnosisListWidth } from 'constants/pagination';
import { NothingDataMindUpAdminPageInPagination } from 'pages/Admin/DCK/AddDiagnosisPage/NothingDataInPagination';
import CustomedPagination from 'components/Pagination/CustomedPagination';
import MindUpAdminDiagnosisListPaginationTable from './MindUpAdminDiagnosisListPaginationTable';
import { LabelSelectButton } from 'components/Common/SortingButton';
import { useLocation } from 'react-router-dom';
import { MindUpAdminPaginationProps } from 'models/Admin/AdminPaginationTypes';
import ArrowLineUp from 'assets/Icons/Arrow/ArrowLineUp';
import ArrowLineDown from 'assets/Icons/Arrow/ArrowLineDown';
import { OtherSortingButton } from 'styles/Global/buttonStyles';

const MindUpAdminDiagnosisListPagination = ({
    currentPage,
    totalPages,
    pageGroup,
    counselData,
    handlePageGroup,
    handlePageChange,
    currentData,
    initNumber,
    handleSorting,
    sortField,
    sortDirections,
    handleResetButton,
    handleReservationAlert,
    handleCounselCompleteAlert,
    handleCounselData,
    onChangeDiagnosisDateModal,
}: MindUpAdminPaginationProps) => {
    const [selectHeader, setSelectHeader] = useState<string>('');

    const { pathname } = useLocation();

    const divideSortingIcon = (name: { title: string; type: string }) => {
        switch (pathname) {
            case '/admin/mindup/today-diagnosis':
            case '/admin/mindup/user-reservation':
                return <OtherSortingButton onClick={() => handleSorting(name.type)}>{sortDirections[name.type] ? <ArrowLineUp /> : <ArrowLineDown />}</OtherSortingButton>;
            case '/admin/mindup/consultation-list':
                return <LabelSelectButton onClick={() => handleSorting(name.type)}>{sortDirections[name.type] ? '시작일순' : '마지막일순'}</LabelSelectButton>;
            default:
                return '';
        }
    };

    return (
        <Layout>
            <TableLayout>
                <HeaderWrapper>
                    {consultationListHeader.map((name, idx) => {
                        return (
                            <TableCell
                                key={idx}
                                $idx={idx}
                                $width={diagnosisListWidth[idx]}
                                $type='header'
                                $justifyContent='space-between'
                                hover={setSelectHeader}
                                cellType={name.type !== 'null' && name.type !== 'patientMobile' ? name.type : undefined}
                            >
                                {name.title}
                                {name.type === 'diagnosisDateTime' && divideSortingIcon(name)}
                                {/* {(sortField === name.type || selectHeader === name.type) &&
                                    name.type !== 'null' &&
                                    name.type !== 'gradeName' &&
                                    name.type !== 'patientMobile' &&
                                    name.type !== 'diagnosisDateTime' && (
                                        <OtherSortingButton onClick={() => handleSorting(name.type)}>{sortDirections[name.type] ? <ArrowLineUp /> : <ArrowLineDown />}</OtherSortingButton>
                                    )} */}
                            </TableCell>
                        );
                    })}
                </HeaderWrapper>
                {currentData?.length === 0 ? (
                    <NothingDataMindUpAdminPageInPagination initNumber={initNumber} handleResetButton={handleResetButton} />
                ) : (
                    <MindUpAdminDiagnosisListPaginationTable
                        currentData={currentData}
                        counselData={counselData}
                        handleCounsellerConfirmAlert={handleReservationAlert}
                        handleCounselData={handleCounselData}
                        handleCounselCompleteAlert={handleCounselCompleteAlert}
                        onChangeDiagnosisDateModal={onChangeDiagnosisDateModal}
                    />
                )}
            </TableLayout>
            {currentData && totalPages !== 0 && (
                <CustomedPagination currentPage={currentPage} onChangeCurrentPage={handlePageChange} onChangeSectionIdx={handlePageGroup} sectionIndex={pageGroup} totalPages={totalPages} />
            )}
        </Layout>
    );
};

export default MindUpAdminDiagnosisListPagination;
